module.exports = __webpack_public_path__ + "assets/img/kv-0e7899e0.jpg";